// extracted by mini-css-extract-plugin
export var modal = "modal-module--modal--67f58";
export var modalCloseBtn = "modal-module--modalCloseBtn--0a80a";
export var modalContent = "modal-module--modalContent--095f6";
export var modalOverlay = "modal-module--modalOverlay--27948";